import React, { Component } from 'react';
import ImageUpload from './upload-images.jsx';
import ImageList from './image-list.jsx';
import { MiniCard } from '../../../commonModules/layouts/CardPage.jsx';
import { CloudUploadRounded, ImageRounded } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
var $ = require('jquery');


class PhotoItemUser extends Component{
    state = {
        // Initiate Time for the chart
        uploadState: false,
        // photoState: 'active',
        // photoStateH: '',
        // uploadStateH: 'hidden',
        listOfImages: []
    }
    // handlePhoto = async (e) => {
    //     e.preventDefault();
    //     this.setState({uploadState: '', photoState: 'active', uploadStateH: 'hidden', photoStateH: ''});
    // }
    handleUploadPhoto = async () => {
        this.setState({ uploadState: true });
    }
    componentDidMount = async () => {
        //Get All Photo Id
        var methodName = 'Get All Photo';
        // var infoBoxID = this.props.boxId
        // if(typeof comment === 'undefined') {
        //     console.log("[DEBUG], componentDidMount,ID is undefined")
        //      infoBoxID = this.props.userID
        // }
        var urlAllimage = "/image/get/all?boxAssoId=" + this.props.boxAssoId;

        this.serverRequest = $.get(urlAllimage, function (result) {
            console.log('[INFO], ', methodName);
            var listOfImg = [];
            try {
                var data = result; //var data = JSON.parse(result);
                console.log(data);
                listOfImg = data.content;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({listOfImages: listOfImg});
        }.bind(this));
    }

    render () {
        var infoBoxID = this.props.boxAssoId
        // if( typeof comment === 'undefined') {
        //     console.log("[DEBUG], ID is undefined")
        //     infoBoxID = this.props.userID
        // }
        return (
            // <div className={this.state.UserInfoStatus}>
            //     <div className="pmb-block clearfix photos">
            //         <div className="p-header">
            //             <ul className="p-menu">
            //                 <li className={this.state.photoState} onClick={this.handlePhoto}>
            //                     <a >
            //                         <i className="zmdi zmdi-image"></i>
            //                         Photos</a>
            //                 </li>
            //                 <li className={this.state.uploadState} onClick={this.handleUploadPhoto}>
            //                     <a >
            //                         <i className="zmdi zmdi-upload"></i>
            //                         Upload</a>
            //                 </li>

            //                 {/*<li><a href=""><i class="zmdi zmdi-play-circle"></i> Videos</a></li>
            //                 <li><a href=""><i class="zmdi zmdi-collection-image"></i> Albums</a></li>*/}
            //             </ul>
            //         </div>
            //     </div>
            //     <div className="lightbox photos">
            //         <div className={this.state.photoStateH}>

            //             <ImageList boxId={infoBoxID} imageList={this.state.listOfImages}/>
            //         </div>

            //         <div className={this.state.uploadStateH}>
            //             <ImageUpload boxId={infoBoxID}/>
            //         </div>
            //     </div>

            // </div>
            <MiniCard 
                title="Photos"
                action={
                    <IconButton onClick={this.handleUploadPhoto} color="secondary" >
                        <CloudUploadRounded />
                    </IconButton>
                }
                avatar={<ImageRounded />}
            >
                {this.state.uploadState &&
                    <ImageUpload {...this.props} />
                }
                <ImageList imageList={this.state.listOfImages}/>
            </MiniCard>

        )
    }
};
export default PhotoItemUser
